import React from 'react';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router';

import { getNameInCurrentLanguage } from 'helpers/intl';
import { parseQs, stringifyQs } from 'helpers/http';

import ListFilterBody from 'components/layout/list/ListFilterBody';

class ListFilterPipelineStage extends React.Component {
  updateStage = (e, stage) => {
    e.preventDefault();

    const { location, history } = this.props;
    history.push({
      pathname: location.pathname,
      search: stringifyQs({ ...parseQs(location.search), stage }),
    });
  };

  render() {
    const {
      intl: { messages },
      appIntl,
      stages,
      location,
    } = this.props;

    const query = parseQs(location.search);
    const isActive = !!query.stage;

    return (
      <ListFilterBody
        title={messages.stage}
        isActive={isActive}
        paramNames={['stage']}
        body={
          <div className="list-view clearfix">
            <ul className="no-border">
              {stages.map(pipelineStage => {
                return (
                  <li key={pipelineStage.id}>
                    <a
                      className="p-t-5 p-b-5 relative block"
                      href="#updateStage"
                      onClick={e => this.updateStage(e, pipelineStage.id)}
                    >
                      <span className="top-left m-t-5">
                        {query.stage === pipelineStage.id ? (
                          <i className="fa-fw fas fa-check-square text-primary" />
                        ) : (
                          <i className="fa-fw fas fa-square text-master-lighter" />
                        )}
                      </span>
                      <span className="m-l-25 block">{getNameInCurrentLanguage(pipelineStage.name, appIntl)}</span>
                    </a>
                  </li>
                );
              })}
            </ul>
          </div>
        }
      />
    );
  }
}
ListFilterPipelineStage.defaultProps = {};

export default withRouter(injectIntl(ListFilterPipelineStage));
